"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Favourite = function Favourite(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M0 0V24H24V0H0ZM16 12.5H13.2071L15.1821 14.475C15.2735 14.5692 15.3242 14.6957 15.3232 14.827C15.3223 14.9583 15.2696 15.0839 15.1768 15.1768C15.0839 15.2696 14.9583 15.3222 14.827 15.3232C14.6956 15.3242 14.5692 15.2734 14.475 15.182L12.5 13.207V16C12.5 16.1326 12.4473 16.2598 12.3536 16.3536C12.2598 16.4473 12.1326 16.5 12 16.5C11.8674 16.5 11.7402 16.4473 11.6464 16.3536C11.5527 16.2598 11.5 16.1326 11.5 16V13.2071L9.525 15.1821C9.4788 15.2295 9.42364 15.2674 9.36271 15.2933C9.30178 15.3193 9.2363 15.3329 9.17006 15.3333C9.10384 15.3338 9.03818 15.3211 8.9769 15.2959C8.91563 15.2708 8.85996 15.2337 8.81313 15.1869C8.7663 15.14 8.72924 15.0844 8.7041 15.0231C8.67897 14.9618 8.66626 14.8961 8.66671 14.8299C8.66717 14.7637 8.68077 14.6982 8.70675 14.6373C8.73272 14.5764 8.77053 14.5212 8.818 14.475L10.793 12.5H8C7.86739 12.5 7.74021 12.4473 7.64645 12.3536C7.55268 12.2598 7.5 12.1326 7.5 12C7.5 11.8674 7.55268 11.7402 7.64645 11.6464C7.74021 11.5527 7.86739 11.5 8 11.5H10.7929L8.81789 9.525C8.77043 9.4788 8.73262 9.42364 8.70666 9.3627C8.6807 9.30177 8.6671 9.23629 8.66666 9.17006C8.66621 9.10383 8.67894 9.03817 8.70408 8.9769C8.72922 8.91562 8.76629 8.85996 8.81313 8.81313C8.85997 8.7663 8.91564 8.72924 8.97692 8.70411C9.0382 8.67898 9.10386 8.66627 9.17009 8.66673C9.23632 8.66718 9.3018 8.68079 9.36273 8.70677C9.42365 8.73274 9.47881 8.77056 9.525 8.81803L11.5 10.793V8C11.5 7.86739 11.5527 7.74021 11.6464 7.64645C11.7402 7.55268 11.8674 7.5 12 7.5C12.1326 7.5 12.2598 7.55268 12.3536 7.64645C12.4473 7.74021 12.5 7.86739 12.5 8V10.7929L14.475 8.81803C14.5211 8.77011 14.5763 8.73186 14.6373 8.70553C14.6983 8.67919 14.764 8.66529 14.8305 8.66464C14.897 8.66399 14.9629 8.67661 15.0245 8.70175C15.086 8.72689 15.1419 8.76405 15.1889 8.81106C15.2359 8.85807 15.2731 8.91399 15.2983 8.97553C15.3234 9.03708 15.336 9.10301 15.3354 9.16949C15.3347 9.23597 15.3208 9.30165 15.2945 9.3627C15.2681 9.42374 15.2299 9.47892 15.182 9.525L13.207 11.5H16C16.1326 11.5 16.2598 11.5527 16.3536 11.6464C16.4473 11.7402 16.5 11.8674 16.5 12C16.5 12.1326 16.4473 12.2598 16.3536 12.3536C16.2598 12.4473 16.1326 12.5 16 12.5Z",
    fill: props.foregroundColor
  }));
};

Favourite.defaultProps = {
  altText: "Favourite",
  backgroundColor: "#FFFFFF",
  foregroundColor: "#2D5AB4"
};
Favourite.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Favourite;
exports.default = _default;